import { render, staticRenderFns } from "./CardShippingOrder.vue?vue&type=template&id=8a555164&scoped=true&"
import script from "./CardShippingOrder.vue?vue&type=script&lang=js&"
export * from "./CardShippingOrder.vue?vue&type=script&lang=js&"
import style0 from "./CardShippingOrder.vue?vue&type=style&index=0&id=8a555164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a555164",
  null
  
)

export default component.exports